import React from 'react';
import styles from './styles.module.css';
import { Tooltip } from '@mui/material';
import BodySilhouette from '../../../../components/bodySilhouette/BodySilhouette';
import { BODY_MEASURES } from '../../modules/bodyMeasures';
import BodyIndicatorCards from './BodyIndicatorCards';
import BodyMeasurePreview from './BodyMeasurePreview';
import BodyExtraMeasures from './BodyExtraMeasures';
import { computeDelta, formatDelta, formatMeasure, getValue } from './bodyMeasurementsMath';

/**
 * Visão geral de uma avaliação: silhueta com as circunferências registradas e
 * os indicadores ao lado; abaixo, as medidas sem lugar na silhueta (dobras,
 * diâmetros, braço contraído). `reference` (opcional) é a avaliação com que se
 * compara; sem ela, nenhuma variação aparece. Com `onSelect(key)`, etiquetas,
 * cartões e itens mostram a prévia da medida ao passar o mouse e abrem o
 * histórico ao clicar.
 */
const BodyOverview = ({ history, current, reference, variant, birthday, onSelect }) => {
  const circumferences = BODY_MEASURES
    .filter((measure) => measure.anchor)
    .map((measure) => {
      const value = getValue(current, measure.key);
      if (value === null) return null;
      const delta = reference ? computeDelta(value, getValue(reference, measure.key)) : null;
      return {
        key: measure.key,
        side: measure.anchor.side,
        title: measure.label,
        value: formatMeasure(value, measure.key),
        note: formatDelta(delta, measure.key),
        preview: onSelect ? <BodyMeasurePreview history={history} measureKey={measure.key} /> : null,
      };
    })
    .filter(Boolean);

  return (
    <div className={styles.overview}>
      <div className={styles.overviewFigure}>
        <BodySilhouette variant={variant} labels={circumferences} onLabelClick={onSelect} />

        {circumferences.length > 0 && (
          <div className={styles.mobileMeasures}>
            {circumferences.map((item) => (
              <Tooltip
                key={item.key}
                title={item.preview || ''}
                placement="top"
                enterDelay={300}
                componentsProps={{ tooltip: { className: styles.previewTip } }}
              >
                <div
                  className={`${styles.mobileMeasure} ${onSelect ? styles.selectable : ''}`}
                  role={onSelect ? 'button' : undefined}
                  tabIndex={onSelect ? 0 : undefined}
                  onClick={onSelect ? () => onSelect(item.key) : undefined}
                  onKeyDown={onSelect ? (event) => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); onSelect(item.key); } } : undefined}
                >
                  <span className={styles.mobileMeasureLabel}>{item.title}</span>
                  <span className={styles.mobileMeasureValue}>{item.value}</span>
                  {item.note && <span className={styles.mobileMeasureDelta}>{item.note}</span>}
                </div>
              </Tooltip>
            ))}
          </div>
        )}
      </div>

      <BodyIndicatorCards
        history={history}
        current={current}
        reference={reference}
        variant={variant}
        birthday={birthday}
        onSelect={onSelect}
      />

      <BodyExtraMeasures current={current} reference={reference} />
    </div>
  );
};

export default BodyOverview;
